import React, { memo, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Select, ISelectOption } from 'components/forms/Selects'
import { getUsers } from 'utils/actions/users'
import { IUserOption, selectUsersAutoComplete } from 'utils/selectors/users'

export interface IDispatcherSelectProps {
  carrierId: string
  dispatcherId?: string
  onChange: (dispatcherId: Partial<IUserOption>) => void
  large?: boolean
  fetchList?: boolean
  required?: boolean
  validationMessage?: string
  invalid?: boolean
  label?: string
}

export const DispatcherSelect = memo<IDispatcherSelectProps>(
  ({
    carrierId,
    dispatcherId,
    fetchList = true,
    invalid,
    large,
    onChange,
    required,
    validationMessage,
  }) => {
    const dispatch = useDispatch()
    const dispatchers = useSelector(selectUsersAutoComplete)

    /**
     * Dispatch fetch on mount, only once
     */
    useEffect(() => {
      if (fetchList) {
        dispatch(
          getUsers({
            filters: {
              carrierId,
              userType: ['dispatcher', 'owner_operator'],
            },
          })
        )
      }
    }, [carrierId, dispatch, fetchList])

    /**
     * Convert dispatchers list to ISelectOption<number>[]
     */
    const dispatcherOptions: ISelectOption<
      string
    >[] = dispatchers.map(({ id: value = '', text: label = '' }) => ({ label, value }))

    const dispatcherHandler = useCallback((option: ISelectOption<string>) => onChange(option), [
      onChange,
    ])

    return (
      <Select
        label='Dispatcher'
        placeholder='Select a Dispatcher'
        options={dispatcherOptions}
        value={`${dispatcherId}`}
        onChange={dispatcherHandler}
        large={large}
        required={required}
        validationMessage={validationMessage}
        invalid={invalid}
        dataTest='dispatcher-select'
      />
    )
  }
)
